import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ProfileState {
  id: number;
  subscriber_profile: any;
  first_name: string;
  last_name: string;
  middle_name: string;
}

const initialState: ProfileState = {
  id: 0,
  subscriber_profile: '',
  first_name: '',
  last_name: '',
  middle_name: '',
};

const ProfileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setSubscriber: (state, { payload }: PayloadAction<any>) => {
      state.id = payload?.id?.value;
      state.subscriber_profile = payload?.subscriber_profile;
      state.first_name = payload?.first_name?.value;
      state.last_name = payload?.last_name?.value;
      state.middle_name = payload?.middle_name?.value;

      return state;
    },
  },
});

const { reducer, actions } = ProfileSlice;

// Actions
export const { setSubscriber } = actions;

export const profileReducer = reducer;
